import { useParams } from 'react-router-dom';
import TestDetails from '../components/TestDetails/TestDetails';

export function TestDetailsPage() {
  const { testId } = useParams();

  return <TestDetails sx={{ margin: '500px' }} id={testId} showCloseButton={false} inDialog={false} />;
}
